<template>
  <div>
    <hr />
    {{words}}
  </div>
</template>

<script>
export default {
  name: "Display_PaneResponse_PartingWords",
  components: {},
  created(){},
  mounted() {},
  props: {
    words: {
      type: String,
      required: false,
      default:""
    }
  },
  computed: {},
  methods: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
